import { decorate, observable, action, reaction, makeObservable } from 'mobx';
import axios from 'axios';

class contextStore {
  data={};
  mouse={};
  type=null;
  par=null;
  constructor(par) {
    makeObservable(this,{
      data:observable,
      mouse:observable,
      type:observable,
    });
    this.par=par;
  }
  hide() {
    this.type=null;
    this.mouse= {};
    this.data= {};
  }
  show(e,type,data) {
    e.preventDefault();
    this.mouse={
      x:e.pageX,
      y:e.pageY
    };
    this.type=type;
    this.data=data;
    console.log(this.mouse.x,this.mouse.y);
  }

}

/*decorate(contextStore,{
  data:observable,
  mouse:observable,
  type:observable,
});*/

export default contextStore;
